import React from 'react'
import { Link } from 'react-router-dom'

export default class OrderUsers extends React.Component {
  render () {
    const { order } = this.props

    const users = order.users.reduce((sum, x, i) => {
      if (!sum.find(xx => xx.user.id === x.user.id)) {
        return [...sum, x]
      }
      return sum
    }, [])

    return (
      <div className='widget'>
        <div className='widget-header' style={{ display: 'flex', alignItems: 'center' }}>
          <h3 style={{ flex: 1 }}><i className='fa fa-tasks' /> Participant</h3>
          {this.props.canEditVeto && (
            <button
              type='button'
              className='btn btn-default btn-xs'
              onClick={this.props.onEditVeto}
            >
              <i className='fa fa-pencil' /> Edit Veto Person
            </button>
          )}
        </div>
        <div className=''>
          <table className='table' style={{ marginBottom: 0 }}>
            <thead>
              <tr>
                <th>User</th>
                <th>Role / Standard</th>
              </tr>
            </thead>
            <tbody>
              { users.length === 0 &&
                <tr>
                  <td colSpan={2}>
                    <p>Not available</p>
                  </td>
                </tr>
              }
              { users.map((x, y) => {
                return (
                  <tr key={y}>
                    <td><Link to={`/users/${x.user.id}`}>{x.user.data ? x.user.data.display_name : x.user.username}</Link></td>
                    <td>
                      {x.role} {x.status === 'Draft' && <small>(draft)</small>}
                      {x.role === 'Veto Person' && (
                        <div style={{ marginTop: 4 }}>
                          {(x.standards && x.standards.length)
                            ? x.standards.map(s => (
                              <span key={s.id} className='label label-success' style={{ marginRight: 4 }}>{s.name}</span>
                            ))
                            : <small className='text-muted'>no standard assigned</small>}
                        </div>
                      )}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}
